import ResultSolution from './ResultSolution';

export default ResultSolution;
